InputView = require("views/input")
{ DraggyView } = require("views/components/draggy")

class QuadrantSurveyView extends InputView
  template: require("./template")
  isScrolledDown: false

  events: ->
    "iostap .btn-done": "nextSlide"
    "iostap .btn-up": "scrollUp"
    "iostap .btn-down": "scrollDown"

  refresh: (params) ->
    currentData = @options.data
    nextData = params.data

    isQuestionChanged = !_.isMatch(currentData.question, nextData.question)

    isZonesChanged = -> _.some(currentData.zones, (zone, i) ->
      !_.isMatch(zone, nextData.zones[i])
    )

    isWordsChanged = -> (currentData.words.length != nextData.words.length) ||
      _.some(currentData.words, (word, i) ->
        !_.isMatch(word, nextData.words[i])
      )

    super(params)

    # scroll from the initial render state
    if isQuestionChanged && this.isScrolledDown
        @scrollDown(false)
        @scrollUp()
    else if isZonesChanged() || isWordsChanged()
      if this.isScrolledDown
        @scrollDown(false)
      else
        @scrollDown(true)

  show: ->
    @listenTo this, "resize", @onResize
    if @draggies
      draggy.undelegateEvents() for draggy in @draggies

    @draggies =
      for el, i in @findAll(".draggy")
        draggy = new DraggyView
          el: el

        @listenTo draggy, "drag", @onDrag
        @listenTo draggy, "drop", @onDrop
        draggy

    @droppies = @getElements(".droppy", null)

    @el.classList.add "ready"

  getElements: (selector, original) ->
    if original
      for {el, contains} in original
        { el, contains, bounds: el.getBoundingClientRect() }
    else
      for el, i in @findAll(selector)
        el: el
        bounds: el.getBoundingClientRect()
        contains: []

  onDrag: (draggy, isInitialDrag) ->
    @droppies   = @getElements(".droppy", @droppies) if isInitialDrag
    activeIndex = draggy.closest(_.pluck(@droppies, "bounds"))
    for droppy, i in @droppies
      droppy.el.classList.toggle("active", i is activeIndex)
      droppy.isActive = i is activeIndex

    if isInitialDrag
      draggy.el.className = draggy.el.className.replace(/delay-\d/, "")
    
    #show fullname
    $(draggy.el).html(draggy.el.dataset.name)

    @transform draggy.el,
      x: draggy.x
      y: draggy.y
      transition: if isInitialDrag then "all 300ms" else "none"

  onDrop: (draggy) ->
    droppy = (droppy for droppy in @droppies when droppy.isActive)[0]
    if droppy and droppy.el # dropped in the zone
      # remove form other droppies contains
      for dropzone, i in @droppies
        dropzone.contains = dropzone.contains.filter (drag) -> drag isnt draggy
      # add to current dropzone
      droppy.contains.push draggy
    else # not drop in a zone, put it back to the position
     draggy.resetPosition()
     @transform draggy.el,
      x: draggy.x
      y: draggy.y
      transition: "all 300ms"
    
    @renderZones()
    # use @$ in backbone view to select elements only in the current view. Without it the result is going to be any element in the whole DOM tree
    # if you have more than one quadrant template, only using $ only might give you elements on previous slide.
    if $('.js-words').is(':empty')
      isComplete = "touched"
      @formatValue()
    else
      isComplete = "prompt"
    @setState(isComplete)
    

  renderZones: ->
    for droppy, i in @droppies
      for draggy, j in droppy.contains
        el = draggy.el
        draggy.resetPosition()
        @transform el,
          x: 0
          y: 0
          transition: "none"

        #show shortname
        $(el).html(el.dataset.short)
        $(el).detach().appendTo(droppy.el)

  scrollUp: (transition = true) ->
    $('#lesson-header').show()
    $(@el).find('.js-slide-page').removeClass('slide-page--active')
    $scroller = $(@el).find('.js-scroller')
    @transform $scroller[0],
      x: 0
      y: 0
      transition: if transition then "all 300ms" else "none"
    $(@el).find('.btn-up').hide()
    this.isScrolledDown = false

  scrollDown: (transition = true) ->
    $firstPage = $(@el).find('.js-slide-page').first()
    $firstPage.next().addClass('slide-page--active')
    $('#lesson-header').hide()
    @onResize(transition)
    $(@el).find('.btn-up').show()
    this.isScrolledDown = true

  onResize: (transition = false) ->
    $scroller = $(@el).find('.js-scroller')
    $firstPage = $(@el).find('.js-slide-page').first()
    if $firstPage.next().hasClass('slide-page--active')
      pageHeight = $firstPage.height() + parseInt($firstPage.css('margin-bottom'))
      @transform $scroller[0],
        x: 0
        y: "-#{pageHeight}px"
        transition: if transition then "all 300ms" else "none"

  formatValue: ->
    @value = ''
    for droppy, i in @droppies
      names = droppy.contains.map (draggy) ->
        draggy.el.dataset.name
      zoneName = droppy.el.dataset.name
      @value += if i is 0 then "#{zoneName}:#{names.join(',')}" else "|#{zoneName}:#{names.join(',')}"
    console.log @value

  userInput: ->
    quadrantResponse: @value
    question:
      content: @options.data.question.content
      id: @options.data.question.id

  submit: (e) ->
    $('#lesson-header').show()
    super



module.exports = QuadrantSurveyView
